import React from 'react';
import { Box, Paper, Typography, Button, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NgeniusCancelled = () => (
  <Box sx={{ p: 3, maxWidth: 640, mx: 'auto' }}>
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Payment Cancelled</Typography>
      <Alert severity="warning" sx={{ mb: 2 }}>
        The online payment was cancelled before completion. The status will be reflected within 30 minutes and the invoice will
        be re-opened for a new attempt. You can also retry now from the Payments page.
      </Alert>
      <Button component={RouterLink} to="/payments" variant="contained" sx={{ textTransform: 'none' }}>
        Back to Payments
      </Button>
    </Paper>
  </Box>
);

export default NgeniusCancelled;
